import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Search} from '../search.js';

import {discoverySearchFactory} from './discovery-search.factory.js';

import PALETTE_SCHEMA from './discovery-search.palette-schema.yaml';

class DiscoverySearchFeature extends AbstractVisualFeature {
    get name() {
        return 'DiscoverySearch';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return discoverySearchFactory(PALETTE);
    }
}

new DiscoverySearchFeature(Search);
